import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue').then(m => m.default)
  },
  {
    path: '/getInvolved',
    name: 'GetInvolved',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "getInvolved" */ '../views/GetInvolved.vue').then(m => m.default)
  },
  {
    path: '/resources',
    name: 'Resources',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "resource" */ '../views/Resources.vue').then(m => m.default)
  },
  {
    path: '/resourcesShareables',
    name: 'ResourcesSharables',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "resourcesShareables" */ '../views/ResourcesShareables.vue').then(m => m.default)
  },
  {
    path: '/resourcesBusinessCards',
    name: 'ResourcesBusinessCards',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "resourcesBusinessCards" */ '../views/ResourcesBusinessCards.vue').then(m => m.default)
  },
  {
    path: '/resourcesFlyers',
    name: 'ResourcesFlyers',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "resourcesFlyers" */ '../views/ResourcesFlyers.vue').then(m => m.default)
  },
  {
    path: '/resourcesInfographics',
    name: 'ResourcesInfographics',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "resourcesInfographics" */ '../views/ResourcesInfographics.vue').then(m => m.default)
  },
  {
    path: '/resourcesInvitations',
    name: 'ResourcesInvitations',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "resourcesInvitations" */ '../views/ResourcesInvitations.vue').then(m => m.default)
  },
  {
    path: '/resourcesStorage',
    name: 'ResourcesStorage',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "resourcesStorage" */ '../views/ResourcesStorage.vue').then(m => m.default)
  },
  {
    path: '/resourcesThankYou',
    name: 'ResourcesThankYou',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "resourcesThankYou" */ '../views/ResourcesThankYou.vue').then(m => m.default)
  },
  {
    path: '/resourcesAbout',
    name: 'ResourcesAbout',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "resourcesAbout" */ '../views/ResourcesAbout.vue').then(m => m.default)
  },
  {
    path: '/resourcesSafeMilksharing',
    name: 'ResourcesSafeMilksharing',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "resourcesSafeMilksharing" */ '../views/ResourcesSafeMilksharing.vue').then(m => m.default)
  },
  {
    path: '/resourcesOther',
    name: 'ResourcesOther',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "resourcesOther" */ '../views/ResourcesOther.vue').then(m => m.default)
  },
  {
    path: '/donatingAndRequesting',
    name: 'DonatingAndRequesting',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "donatingAndRequesting" */ '../views/DonatingAndRequesting.vue').then(m => m.default)
  },
  {
    path: '/chapters',
    name: 'Chapters',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "chapters" */ '../views/Chapters.vue').then(m => m.default)
  },
  {
    path: '/news',
    name: 'News',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "news" */ '../views/News.vue').then(m => m.default)
  },
  {
    path: '/contact',
    name: 'Contact',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "contact" */ '../views/Contact.vue').then(m => m.default)
  },
  {
    path: '/blog',
    name: 'Blog',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "blog" */ '../views/Blog.vue').then(m => m.default),
    props: () => ({ postName: '' })
  },
  {
    path: '/blog/:postName',
    name: 'Blog/Posts',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "blog" */ '../views/Blog.vue').then(m => m.default),
    props: (route) => ({
      postName: route.params.postName
    })
  },
  {
    path: '/covid',
    name: 'Covid',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "covid" */ '../views/Covid.vue').then(m => m.default)
  },
  {
    path: '/4pillars',
    name: '4Pillars',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "safeMilkSharing" */ '../views/SafeMilkSharing.vue').then(m => m.default)
  },

  {
    path: '/admin',
    name: 'admin',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "admin" */ '../views/Admin.vue').then(m => m.default)
  }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router
